export const LESSON_TYPES = ['grammar', 'reading', 'writing', 'grammar-drill'];
export const lessonLabel = type => ({ grammar: 'Grammar', reading: 'Reading', writing: 'Writing', 'grammar-drill': 'Grammar drill' }[type] || type);
export const defaultExerciseType = type => ({ reading: 'comprehension', writing: 'open', 'grammar-drill': 'translate' }[type] || 'translate');
export const wordCount = value => value.trim().split(/\s+/u).filter(Boolean).length;
export const writingCriteria = exercise => exercise.criteria?.length ? exercise.criteria : [
  'I answered every part of the task.',
  'I checked my grammar, spelling, and punctuation.',
];

export function isCorrectAnswer(value, expected, strict = false) {
  const normalize = input => {
    let text = String(input).normalize('NFC').toLowerCase().replace(/[’‘]/g, "'");
    // Grammar drills preserve accents and apostrophes: these can be the point being practised.
    if (!strict) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/['"]/g, '');
    return text.replace(/[.,!?;:«»]/g, '').replace(/\s+/g, ' ').trim();
  };
  const answer = normalize(value);
  return !!answer && (expected || []).some(candidate => normalize(candidate) === answer);
}

export const initialExerciseState = () => ({ value: '', checked: false, correct: false, attempts: 0, firstCorrect: null, reviewed: false });
